import React from 'react';
import AnimateHeight from 'react-animate-height';
import { Heading } from 'components/LANDR/Heading';
import './Faq.scss';
import { Container } from 'components/UI/Container/Container';
import { PrismicHTMLParser } from 'components/PrismicHTMLParser';
import { Grid, GridRow, GridCol } from 'components/UI/Grid';
import {
    BooleanOptionType,
    PrismicRichTextFieldType,
    PrismicTitleFieldType,
    ThemeOptionType,
} from '../types';

type Item = {
    faq_question: PrismicRichTextFieldType;
    faq_answer: PrismicRichTextFieldType;
};

type FaqProps = {
    slice: {
        slice_type: string;
        primary: {
            faq_title: PrismicTitleFieldType;
            faq_note: PrismicRichTextFieldType;
            faq_theme: ThemeOptionType;
            faq_multiple_open_items: BooleanOptionType;
        };
        items: Item[];
    };
};

type FaqState = {
    openItems: number[];
};

const AccordionSection = (section: {
    isOpen: boolean;
    onClick: (event: any) => void;
    theme: string;
    item: Item;
}) => {
    const { faq_question: question, faq_answer: answer } = section.item;
    return (
        <div
            className={`FaqItem FaqItem--${section.theme.toLowerCase()}`}
            onClick={section.onClick}
        >
            <PrismicHTMLParser
                className={`FaqItem-questionText FaqItem-questionText--${section.theme.toLowerCase()}`}
            >
                {question.html || ''}
            </PrismicHTMLParser>
            {section.isOpen ? (
                <span className="FaqItem-icon  FaqItem-icon--open" />
            ) : (
                <span className="FaqItem-icon  FaqItem-icon--closed" />
            )}
            <AnimateHeight
                className="FaqItem-heightWrapper"
                duration={500}
                height={section.isOpen ? 'auto' : 0}
            >
                <PrismicHTMLParser
                    className={`FaqItem-answer FaqItem-answer--${section.theme.toLowerCase()}`}
                >
                    {answer.html || ''}
                </PrismicHTMLParser>
            </AnimateHeight>
        </div>
    );
};

class Faq extends React.Component<FaqProps, FaqState> {
    constructor(props: FaqProps) {
        super(props);

        this.state = {
            openItems: [],
        };
    }

    handleClick = (i: number) => () => {
        this.setState((state: FaqState) => {
            let openItems = [...state.openItems];

            if (openItems.includes(i)) {
                // Remove the item from the openItems array if already in the array
                openItems.splice(openItems.indexOf(i), 1);
            } else {
                if (this.props.slice.primary.faq_multiple_open_items === 'Yes') {
                    // If multiple items can be open, simply add the new one
                    openItems.push(i);
                } else {
                    // Otherwise, remove any other open ones
                    openItems = [i];
                }
            }

            return { openItems };
        });
    };
    renderItems = () => {
        return this.props.slice.items.map(
            (item, index) =>
                item.faq_question.html &&
                item.faq_answer.html && (
                    <AccordionSection
                        key={index}
                        isOpen={this.state.openItems.includes(index)}
                        onClick={this.handleClick(index)}
                        theme={this.props.slice.primary.faq_theme}
                        item={item}
                    />
                ),
        );
    };
    render() {
        const {
            slice: {
                primary: { faq_note: note, faq_title: title, faq_theme: theme },
            },
        } = this.props;
        return (
            <div className={`Faq Faq--${theme.toLowerCase()}`}>
                <Container size="md">
                    {title.raw && (
                        <Grid>
                            <GridRow horizontalAlign={'h-center'} verticalAlign={'v-center'}>
                                <GridCol colSize={`10`} offsetSize={`0`} mobileColSize={'12'}>
                                    <Heading
                                        className={`Faq-title Faq-title--${theme.toLowerCase()}`}
                                        size="xl"
                                        element={title.raw[0].type}
                                    >
                                        {title.raw[0].text}
                                    </Heading>
                                    {this.renderItems()}
                                    {note && (
                                        <PrismicHTMLParser
                                            className={`Faq-note Faq-note--${theme.toLowerCase()}`}
                                        >
                                            {note.html || ''}
                                        </PrismicHTMLParser>
                                    )}
                                </GridCol>
                            </GridRow>
                        </Grid>
                    )}
                </Container>
            </div>
        );
    }
}

export { Faq, FaqProps };
